/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_DeletingInputs */

const en_carrier_notices_deleting = /** @type {(inputs: Carrier_Notices_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting...`)
};

const es_carrier_notices_deleting = /** @type {(inputs: Carrier_Notices_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminando...`)
};

/**
* | output |
* | --- |
* | "Deleting..." |
*
* @param {Carrier_Notices_DeletingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_deleting = /** @type {((inputs?: Carrier_Notices_DeletingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_DeletingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_deleting(inputs)
	return es_carrier_notices_deleting(inputs)
});